import { useAuth } from '@/@diffrag/providers/user.provider'
import { AuthResponse } from '@/type'
import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const OAuth = () => {
  const { sync } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const jsonStringData = Cookies.get('auth-response')

    if (!jsonStringData) {
      return
    }

    let data: AuthResponse | undefined = undefined

    try {
      data = JSON.parse(jsonStringData) as AuthResponse

      Cookies.set('admin_access_token', data.accessToken, {
        secure: true,
        sameSite: 'lax',
        expires: undefined,
      })

      if (!sync()) {
        alert('관리자 권한이 없습니다.')
        navigate('/login', { replace: true })
      }
    } catch (e) {
      console.warn(e)
      console.warn(jsonStringData)
    }
  }, [])

  return <div>Redirect...</div>
}
